// Styles
import '../sass/main.scss';

// Javascript
import './ctcdn';
import './frontend/header';
import './frontend/custom';
import "../../node_modules/bootstrap/dist/js/bootstrap.js";
